// @core/api/endpoints/fiscalization/get_fiscal_point.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetFiscalPointResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Get fiscal point by ID
 * Retrieves a fiscal point with its current status, shift info, and fiscal drive details.
 */
export async function GetFiscalPoint(
  id: string,
  options?: RequestOptions
): Promise<GetFiscalPointResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-points/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetFiscalPointResponse>(requestPath, { ...requestOptions });
}
